// extracted by mini-css-extract-plugin
module.exports = {"root":"Storage_root__12xUB","table":"Storage_table__3F5YM","tableWrapper":"Storage_tableWrapper__1hb1n"};